import React from "react";
import Navbar from "./components/Navbar";
import Tagline from "./components/Tagline";
import Projects from "./components/Projects";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Connect from "./components/Connect";
import { Element } from "react-scroll";

function App() {
  const [theme, setTheme] = React.useState("dark");

  React.useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return (
    <div className="App" data-theme={theme}>
      <Navbar
        theme={theme}
        onToggleTheme={() =>
          setTheme((currentTheme) =>
            currentTheme === "dark" ? "light" : "dark",
          )
        }
      />
      <Element name="home">
        <Tagline />
      </Element>

      <Element name="projects">
        <Projects />
      </Element>
      <Element name="testimonials">
        <Testimonials />
      </Element>
      <About />
      <Element name="experience">
        <Experience />
      </Element>
      <Element name="services">
        <Skills />
      </Element>
      <Element name="contact">
        <Connect />
      </Element>
    </div>
  );
}

export default App;
